import { useCallback } from 'react';
import { useRootStackNavigation } from '../../../../hooks/useRootNavigation';

/**
 * - 비밀번호 찾기 화면으로 이동
 */
export const useMoveToRecoveryPassword = () => {
  const navigation = useRootStackNavigation();

  return useCallback(() => {
    navigation.push('RecoveryPassword', {});
  }, [navigation]);
};
